import { buscaDadosv2 } from '../services';

export async function getAddress(cpf, contract) {
    const dados = await buscaDadosv2(cpf, contract);

    if (!dados[0]) return {};

    const dadosTitular = dados.find((beneficiario) => beneficiario.tipo === 'TITULAR');

    if (!dadosTitular) return {};

    const { nomeMunicipioAtendimento, ufAtendimento, codigoMunicipioAtendimento } = dadosTitular?.enderecos[0]
        ? dadosTitular?.enderecos[0]
        : dadosTitular?.enderecos;

    return { nomeMunicipioAtendimento, ufAtendimento, codigoMunicipioAtendimento, dados: dadosTitular };
}
